import React, { useEffect, useRef } from 'react'
import * as d3 from 'd3'
import useSize from 'hooks/useSize'
import './styles.scss'

const isMobile = window.innerWidth < 900

interface MiniFortuneChartProps {
  data: { year: number; fortune: number }[]
  isSmall: boolean
}

export const MiniFortuneChart = ({ data, isSmall }: MiniFortuneChartProps) => {
  const svgRef = useRef<SVGSVGElement>(null)
  const [container, size] = useSize()
  const width = size.width
  const height = width * (isMobile ? 0.3 : 0.3)
  const padding = 6
  const gutterTop = padding
  const gutterRight = 20
  const gutterLeft = 15
  const gutterBottom = 20
  const plotArea = {
    top: gutterTop,
    right: width - gutterRight,
    left: gutterLeft,
    bottom: height - gutterBottom
  }

  const xAxisScale = React.useMemo(
    () =>
      d3
        .scaleLinear()
        .domain([d3.min(data, d => d.year), d3.max(data, d => d.year)])
        .range([plotArea.left, plotArea.right]),
    [size]
  )

  const yAxisScale = React.useMemo(
    () =>
      d3
        .scaleLinear()
        .domain([d3.min(data, d => d.fortune), d3.max(data, d => d.fortune)])
        .range([plotArea.bottom, plotArea.top]),
    [size]
  )

  const yFunction = d => yAxisScale(d.fortune)
  const xFunction = d => xAxisScale(d.year)

  const lineFunction = React.useMemo(
    () =>
      d3
        .line()
        .x(xFunction)
        .y(yFunction),
    [size]
  )

  return (
    <div ref={container} className='minichart-container'>
      {/* {data.map(f => f.year + ': ' + f.fortune + ', ')} */}
      <svg ref={svgRef} width={width} height={height}>
        <path d={lineFunction(data)} />
        {/* {data.map((d, i) => (
          <g className='tick' key={`chart-tick-${i}`}>
            <text x={xAxisScale(d.year)} y={height}>
              {d.year}
            </text>
            <line
              x1={xAxisScale(d.year)}
              y1={plotArea.bottom}
              x2={xAxisScale(d.year)}
              y2={plotArea.bottom + plotArea.top - plotArea.bottom}
            />
          </g>
        ))} */}
        {data.map((d, i) => (
          <circle
            key={`chart-circle-${i}`}
            cx={xAxisScale(d.year)}
            cy={yAxisScale(d.fortune)}
          />
        ))}
      </svg>
      <div className='legend'>
        {data.map((d, i) => (
          <div
            style={{ transform: `translateX(${xAxisScale(d.year)}px)` }}
            className='tick'
            key={`chart-tick-${i}`}
          >
            <div>{d.year}</div>
            <div
              style={{ height: height, transform: `translateY(${-height}px)` }}
              className='bar'
            />
          </div>
        ))}
      </div>
    </div>
  )
}
